// components/SelfPaced/AddModuleForm.js
// Theme-aware inline form for creating / editing modules
import React, { useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { Lock } from 'lucide-react';
import { AppButton } from '../ui';
import './_self-paced-pages.scss';

const UNLOCK_OPTIONS = [
  { key: 'previous_complete', label: 'Complete All Lessons', desc: 'All lessons in previous module must be completed' },
  { key: 'previous_quiz_passed', label: 'Pass Module Quiz', desc: 'Quiz in previous module must be passed' },
  { key: 'none', label: 'No Lock', desc: 'Always accessible regardless of progression' },
];

const AddModuleForm = ({ initial, onSave, onCancel, saving, sequential }) => {
  const [title, setTitle] = useState(initial?.title || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [unlockCriteria, setUnlockCriteria] = useState(initial?.unlockCriteria || 'previous_complete');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    onSave({
      title: title.trim(),
      description: description.trim(),
      unlockCriteria,
    });
  };

  return (
    <div className="sp-new-module-form">
      <Form onSubmit={handleSubmit}>
        <h4 className="sp-new-module-form__title">{initial ? 'Edit Module' : 'New Module'}</h4>

        <div className="sp-new-module-form__body">
          <Form.Group className="mb-3">
            <Form.Label className="sp-field-label">
              Module Title <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. Introduction to React Hooks"
              required
              autoFocus
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="sp-field-label">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Brief description of this module..."
            />
          </Form.Group>

          {/* Unlock Criteria — only shown when sequential mode is on */}
          {sequential && (
            <div className="sp-unlock-criteria">
              <label className="sp-field-label">
                <Lock size={13} style={{ marginRight: 4 }} />
                Unlock Requirement
              </label>
              <div className="sp-unlock-criteria__options">
                {UNLOCK_OPTIONS.map(({ key, label, desc }) => (
                  <label
                    key={key}
                    className={`sp-unlock-criteria__option ${unlockCriteria === key ? 'sp-unlock-criteria__option--active' : ''}`}
                  >
                    <Form.Check
                      type="radio"
                      name="unlockCriteria"
                      checked={unlockCriteria === key}
                      onChange={() => setUnlockCriteria(key)}
                    />
                    <div>
                      <span className="sp-unlock-criteria__label">{label}</span>
                      <span className="sp-unlock-criteria__desc">{desc}</span>
                    </div>
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="sp-new-module-form__footer">
          <AppButton variant="outline" size="sm" onClick={onCancel} type="button">
            Cancel
          </AppButton>
          <AppButton size="sm" type="submit" disabled={saving}>
            {saving ? (
              <Spinner size="sm" animation="border" />
            ) : (
              initial ? 'Update' : 'Create Module'
            )}
          </AppButton>
        </div>
      </Form>
    </div>
  );
};

export default AddModuleForm;
